import { Link } from "react-router-dom";
import { Card, Col, Container, Row } from "reactstrap";

import Feature1 from "../assets/images/1.png";
import Feature2 from "../assets/images/2.png";

export default function Feature() {
    const services = [
        {
            id: 'service1',
            icon: 'building',
            title: "Gestion de Copropriété",
            description: "Gérez facilement les immeubles, les copropriétaires et les parties communes en toute transparence."
        },
        {
            id: 'service2',
            icon: 'users-alt',
            title: "Communication avec les Résidents",
            description: "Informez les résidents via des annonces, des mises à jour et des alertes en temps réel."
        },
        {
            id: 'service3',
            icon: 'file-alt',
            title: "Stockage de Documents",
            description: "Centralisez et partagez les PV, factures, règlements et autres documents essentiels."
        },
        {
            id: 'service4',
            icon: 'chart-line',
            title: "Suivi Financier",
            description: "Suivez les dépenses, les appels de fonds et les budgets avec des rapports clairs."
        },
        {
            id: 'service5',
            icon: 'calendar-alt',
            title: "Planification des Travaux",
            description: "Organisez et suivez les interventions et maintenances dans les parties communes."
        },
        {
            id: 'service6',
            icon: 'bell',
            title: "Notifications en Temps Réel",
            description: "Restez informé des événements importants et des demandes urgentes."
        },
    ];

    return (
        <>
            {/*  Services START  */}
            <section className="section" id="features">
                <Container>
                    <Row className="justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2">
                                <h3 className="title mb-3">Fonctionnalités Clés</h3>
                                <p className="text-muted mx-auto para-desc mb-0">
                                    Découvrez comment notre application facilite la gestion de syndic, améliore la transparence et renforce la vie en communauté.
                                </p>
                            </div>
                        </div>
                    </Row>

                    <Row>
                        {services.map((item, key) => (
                            <Col lg={4} md={6} className="mt-5 pt-4" key={key}>
                                <Card className="features feature-primary feature-shadow-md shadow rounded p-4 pt-5">
                                    <div className="icon-style mt-n80 position-relative text-center shadow rounded bg-white mb-4">
                                        <i className={"h4 mb-0 uil uil-" + item.icon}></i>
                                    </div>
                                    <div className="content">
                                        <Link to="#" className="title text-dark h5">{item.title}</Link>
                                        <p className="text-muted mt-3">{item.description}</p>
                                        {/* <Link to="#" className="text-dark title">En savoir plus <i className="uil uil-arrow-right"></i></Link> */}
                                    </div>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>

                <Container className="mt-100 mt-60">
                    <Row>
                        <Col lg={5}>
                            <div className="section-title">
                                <h4 className="section-title mb-3 mb-lg-0">
                                    Des Outils Essentiels <br /> pour les Syndics Modernes
                                </h4>
                            </div>
                        </Col>

                        <Col lg={7}>
                            <p className="text-muted para-desc mb-0">
                                Notre plateforme regroupe les outils nécessaires pour gérer vos immeubles efficacement et en toute simplicité — le tout depuis un tableau de bord centralisé.
                            </p>
                        </Col>
                    </Row>
                </Container>

                <Container className="mt-100 mt-60">
                    <Row className="align-items-center">
                        <Col lg={6} md={6}>
                            <img src={Feature1} className="img-fluid shadow-md rounded-md" alt="Vue analytique" />
                        </Col>

                        <Col lg={6} md={6} className="mt-4 mt-sm-0 pt-2 pt-sm-0">
                            <div className="section-title ms-lg-5">
                                <h4 className="title mb-4">Analyses et Rapports Précis</h4>
                                <p className="text-muted">
                                    Accédez à des données claires sur les finances, les charges et les interventions afin de prendre les bonnes décisions.
                                </p>
                                <ul className="list-unstyled text-muted">
                                    <li className="mb-1"><span className="text-primary h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Rapports de dépenses détaillés</li>
                                    <li className="mb-1"><span className="text-primary h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Relevés clairs pour les copropriétaires</li>
                                </ul>
                                {/* <Link to="#" className="mt-3 text-primary">En savoir plus <i className="uil uil-angle-right-b"></i></Link> */}
                            </div>
                        </Col>
                    </Row>
                </Container>

                <Container className="mt-100 mt-60">
                    <Row className="align-items-center">
                        <Col lg={6} md={6} className="order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0">
                            <div className="section-title me-lg-5">
                                <h4 className="title mb-4">Ne Ratez Plus Rien</h4>
                                <p className="text-muted">
                                    Des alertes urgentes aux rappels d’assemblées, restez connecté en temps réel avec les résidents et gestionnaires.
                                </p>
                                <ul className="list-unstyled text-muted">
                                    <li className="mb-1">
                                        <span className="text-primary h5 me-2">
                                            <i className="uil uil-check-circle align-middle"></i>
                                        </span>
                                        Envoi d’alertes par email aux résidents
                                    </li>
                                    <li className="mb-1">
                                        <span className="text-primary h5 me-2">
                                            <i className="uil uil-check-circle align-middle"></i>
                                        </span>
                                        Gestion manuelle des communications depuis le tableau de bord
                                    </li>
                                </ul>

                                {/* <Link to="#" className="mt-3 text-primary">En savoir plus <i className="uil uil-angle-right-b"></i></Link> */}
                            </div>
                        </Col>

                        <Col lg={6} md={6} className="order-1 order-md-2">
                            <img src={Feature2} className="img-fluid shadow-md rounded-md" alt="Aperçu des notifications" />
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};